import axios from './axios-with-authentication';
import * as backend from './backend-types';
import { API_BASE_PATH } from './constants';
import { toAppError } from './error-mapping';

export type AboutApplicationSettings = {
  supportPhoneNumber?: string;
  supportEmail?: string;
  manufacturerName?: string;
  manufacturerAddressLineOne?: string;
  manufacturerAddressLineTwo?: string;
  manufactureDate?: string;
  systemVersion?: string;
  backendVersion?: string;
  privacyPolicyLinkTemplate?: string;
  cookiePolicyLinkTemplate?: string;
  supportedLocales: string[];
};

function normalizeOptionalString(value?: string): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export async function getAboutApplicationSettings(): Promise<AboutApplicationSettings> {
  try {
    const { data } = await axios.get<backend.PortalConfigurationDto>(
      `${API_BASE_PATH}/configurations`,
    );
    const settings = data.applicationSettings || {};
    const supportedLocales = Array.isArray(data.supportedLocales)
      ? data.supportedLocales
          .map((entry) => normalizeOptionalString(entry))
          .filter((entry): entry is string => Boolean(entry))
      : [];

    return {
      supportPhoneNumber: normalizeOptionalString(settings.supportPhoneNumber),
      supportEmail: normalizeOptionalString(settings.supportEmail),
      manufacturerName: normalizeOptionalString(settings.manufacturerName),
      manufacturerAddressLineOne: normalizeOptionalString(settings.manufacturerAddressLineOne),
      manufacturerAddressLineTwo: normalizeOptionalString(settings.manufacturerAddressLineTwo),
      manufactureDate: normalizeOptionalString(settings.manufactureDate),
      systemVersion: normalizeOptionalString(settings.systemVersion),
      backendVersion: normalizeOptionalString(settings.backendVersion),
      privacyPolicyLinkTemplate: normalizeOptionalString(settings.privacyPolicyLinkTemplate),
      cookiePolicyLinkTemplate: normalizeOptionalString(settings.cookiePolicyLinkTemplate),
      supportedLocales,
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    throw toAppError(err);
  }
}
